import { useEffect, useState } from 'react';

import { useMutation } from '@tanstack/react-query';

import { legalService } from '@chartai/firebase';

export function useLegalConfig() {
  const [data, setData] = useState<Record<string, unknown> | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = legalService.subscribeToLegalConfig((config) => {
      setData(config);
      setIsLoading(false);
    });

    return unsubscribe;
  }, []);

  return { data, isLoading };
}

export function useNeedsConsent(
  userDoc: Record<string, unknown> | null,
  legalConfig: Record<string, unknown> | null,
): boolean {
  if (!userDoc || !legalConfig) {
    return false;
  }

  const termsOk =
    userDoc['termsAccepted'] === true &&
    userDoc['termsAcceptedVersion'] === legalConfig['termsVersion'];
  const privacyOk =
    userDoc['privacyAccepted'] === true &&
    userDoc['privacyAcceptedVersion'] === legalConfig['privacyVersion'];

  return !termsOk || !privacyOk;
}

export function useUpdateConsent() {
  return useMutation({
    mutationFn: async (input: {
      uid: string;
      termsAcceptedVersion: string;
      privacyAcceptedVersion: string;
      acceptedPlatform: 'web' | 'mobile';
    }) => {
      await legalService.updateUserConsent(input.uid, {
        termsAcceptedVersion: input.termsAcceptedVersion,
        privacyAcceptedVersion: input.privacyAcceptedVersion,
        acceptedPlatform: input.acceptedPlatform,
      });
    },
  });
}
